import { render } from "./Callback.vue?vue&type=template&id=a3dab894"
import script from "./Callback.vue?vue&type=script&lang=js"
export * from "./Callback.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\raubart\\Documents\\GitLab\\hyundai_shop\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__